import { CommunityFilteredAnalyticsDTO } from '../dtos/CommunityFilteredAnalytics.dto';
import { CommunityFilteredAnalyticsModel } from '../models/CommunityFilteredAnalytics.model';

export class CommunityFilteredAnalyticsUtil {
  public static mapToViewModel(
    dto: CommunityFilteredAnalyticsDTO,
  ): CommunityFilteredAnalyticsModel {
    return {
      id: dto.id,
      community: dto.communityData.name,
      logo: dto.communityData.logo,
      users: {
        ...dto.userData,
      },
      dailyActive: dto.dailyActive.average,
      views: dto.activityData.views,
      conversions: dto.activityData.conversions,
      notifications: dto.activityData.notifications,
      publishing: {
        client: dto.pubData.community,
        admin: dto.pubData.admin,
        total: dto.pubData.total,
      },
    };
  }
}
